/**
 * src/components/PriceBlock.jsx
 * Shows current price, struck-through original price, a "(X% OFF)" badge,
 * and a "(Save ₹Y on this product!)" line — only when there's actually a
 * discount to show (comparePrice > price).
 */
import { formatINR } from "../lib/supabaseProducts";

export function PriceBlock({ price, comparePrice, size = "lg" }) {
  const hasDiscount = comparePrice && comparePrice > price;
  const percentOff = hasDiscount ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
  const saveAmount = hasDiscount ? comparePrice - price : 0;

  const priceFontSize = size === "lg" ? "1.5rem" : "1rem";
  const compareFontSize = size === "lg" ? "1rem" : "0.8125rem";

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <span style={{ fontSize: priceFontSize, fontWeight: 700 }}>{formatINR(price)}</span>
        {hasDiscount && (
          <>
            <span className="product-card-compare" style={{ fontSize: compareFontSize }}>{formatINR(comparePrice)}</span>
            <span style={{ color: "var(--primary)", fontWeight: 700, fontSize: compareFontSize }}>({percentOff}% OFF)</span>
          </>
        )}
      </div>
      {hasDiscount && (
        <p style={{ color: "var(--primary)", fontWeight: 600, fontSize: 13, marginTop: 4 }}>
          (Save {formatINR(saveAmount)} on this product!)
        </p>
      )}
    </div>
  );
}